class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification =
      document.getElementById('cart-notification');

    this.header =
      document.querySelector('sticky-header');

    this.onBodyClick =
      this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      'keyup',
      (event) => {
        if (event.code === 'Escape') {
          this.close();
        }
      }
    );

    this.querySelectorAll(
      'button[type="button"]'
    ).forEach((button) => {
      button.addEventListener(
        'click',
        this.close.bind(this)
      );
    });
  }


  open() {
  if (this.parentElement !== document.body) {
    document.body.appendChild(this);
  }

  this.notification.classList.add(
    'animate',
    'active'
  );

  this.notification.addEventListener(
    'transitionend',
    () => {
      this.notification.focus();
      trapFocus(this.notification);
    },
    { once: true }
  );

  document.body.addEventListener(
    'click',
    this.onBodyClick
  );
}


  close() {
    this.notification.classList.remove(
      'active'
    );

    document.body.removeEventListener(
      'click',
      this.onBodyClick
    );

    removeTrapFocus(this.activeElement);
  }


  renderContents(parsedState) {
    this.getSectionsToRender().forEach(
      (section) => {

        const target =
          document.getElementById(section.id);

        const source =
          parsedState.sections?.[section.id];

        if (!target || !source) {
          return;
        }

        target.innerHTML =
          this.getSectionInnerHTML(
            source,
            section.selector
          );
      }
    );

    if (this.header) {
      this.header.reveal();
    }

    this.open();
  }


  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }


  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    const documentHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const section =
      documentHTML.querySelector(selector);

    return section
      ? section.innerHTML
      : '';
  }


  handleBodyClick(event) {
    const target = event.target;

    if (
      target !== this.notification &&
      !target.closest('cart-notification')
    ) {

      const disclosure =
        target.closest(
          'details-disclosure, header-menu'
        );

      this.activeElement =
        disclosure
          ? disclosure.querySelector('summary')
          : null;

      this.close();
    }
  }


  setActiveElement(element) {
    this.activeElement = element;
  }
}


customElements.define(
  'cart-notification',
  CartNotification
);